import React from 'react';
import { Paper, Typography, Box, Button, CircularProgress } from '@mui/material';

import { FilterDropdown } from './components';
import useFilters from './useFilters';
import RenderIf from '../../../../renderIf';

const FilterControls = ({
    filters,
    selectedFilters: previouslySelectedFilters,
    disabled,
    isFetching,
    handleFilterChange,
}) => {
    const { selectedFilters, updateSelections, clearAllSelections } = useFilters(filters, previouslySelectedFilters);

    React.useEffect(() => {
        handleFilterChange(selectedFilters, 'filter');
    }, [selectedFilters]);

    return (
        <Paper
            sx={theme=> {
                return {
                    marginTop: theme.spacing(2),
                    marginBottom: theme.spacing(2),
                    padding: theme.spacing(3),
                    borderRadius: '8px',
                    [theme.breakpoints.down('lg')]: {
                        maxWidth: '75vw',
                    },
                    [theme.breakpoints.down('md')]: {
                        maxWidth: '60vw',
                    },
                    [theme.breakpoints.down('sm')]: {
                        maxWidth: 'unset',
                    },
                }
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    gap: '1rem',
                    marginBottom: (theme) => theme.spacing(2),
                }}
            >
                <Typography
                    variant="h5"
                    sx={{ fontSize: '18px', fontWeight: 600 }}
                >
                    Filters
                </Typography>
                <Button
                    className="button-link"
                    disabled={disabled || isFetching}
                    onClick={clearAllSelections}
                    sx={{ fontSize: '10px', fontWeight: 600 }}
                >
                    clear all filters
                </Button>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Box>
                    {Object.entries(filters)?.map?.(([key, filterObj]) => {
                        return (
                            <FilterDropdown
                                key={`filter-${key}`}
                                filterKey={key}
                                label={filterObj.label}
                                filter={filterObj.filters}
                                value={selectedFilters?.[key] ? selectedFilters[key] : []}
                                handleUpdate={updateSelections}
                                disabled={disabled || isFetching}
                            />
                        );
                    })}

                    <RenderIf isTrue={isFetching}>
                        <CircularProgress sx={{ marginLeft: '1rem' }} />
                    </RenderIf>
                </Box>
            </Box>
        </Paper>
    );
};

export default FilterControls;
